:host {
  --gray-12:            #F8F8F8;
  --gray-13:            #e6f0ff;
  --neutral-100:        #F4F4F5;
  --pill-background: var(--gray-12);
  --pill-background-active: var(--gray-13);
}

@media (prefers-color-scheme: dark) {
  :host {
    --pill-background: var(--primary-black);
    --pill-background-active: var(--neutral-100);
  }
}

p {
  margin: 0px;
  padding: 0;
  font-family: var(--body-font);
  font-style: normal;
  line-height: normal;
  font-weight: 400;
}

a {
  color: var(--primary);
  text-decoration: none;
}

/* Newsletter step */
.auth-container .step-container.newsletters {
  display: flex;
  gap: 24px;
  align-items: center;
  padding: 24px 32px;
  flex-direction: column;
}

.newsletters .form-body {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px;
  align-items: flex-start;
  justify-content: start;
  gap: 24px;
  align-self: stretch;

  @media(max-width: 1040px) {
    max-height: 35dvh;
    overflow: scroll;
  }
}

.newsletter-pill {
  display: flex;
  flex-basis: 48%;
  padding: 16px;
  min-height: 108px;
  max-height: 108px;
  align-items: stretch;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var( --border);
  background: var(--pill-background);
  transition: all 0.2s ease;

  @media(max-width: 1040px) {
    flex-basis: 90%;
    min-height: 108px;
    max-height: 120px;
  }
}

.newsletter-pill.active {
  border: 1px solid var(--primary);
  background: var(--input-bg);
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.20);
  font-weight: 600;
}

.newsletter-pill-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
}

.newsletter-pill-container.active {
  border-radius: 4px;
  border: 1px solid var(--primary);
  background: var(--input-bg);
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.20);
}

.newsletter-pill-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  width: 80%;

  h3 {
    color: var(--text-hint);
    padding: 0;
    margin: 0;
    font-family: var(--body-font);
    font-size: var(--font-size-2, 16px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  p {
    color: var(--text-hint);
    font-family: var(--body-font);
    font-size: 14px;
  }
}

.newsletter-pill-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}

.newsletter-pill-selector span {
  display: flex;
  width: 18px;
  height: 18px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 40px;
  border-radius: 40px;
  border: 1px solid var(--primary);
  background: var(--input-bg);
}

.newsletter-pill-selector span.active {
  border: 1px solid var(--primary);
  background: var(--primary);
}

.newsletters-terms {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  align-self: stretch;

  p {
    color: var(--text-body);
    font-size: 12px;
    letter-spacing: 0.06px;
  }

  input[type='checkbox'] {
    accent-color: var(--primary);
  }
}

.newsletters .step-actions {
  flex-direction: column;
  align-items: center;
  gap: 0px;
}

.newsletters .step-actions button.next-step {
  padding: 10px 42px;
  width: 100%;
}

.newsletters .step-actions button:disabled {
  cursor: not-allowed;
  background-color: var(--primary-70);
  border-color: var(--primary-70);
}

.remind-me {
  font-size: 16px;
  color: var(--text-body);

  a {
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    line-height: 32px;
  }
}

.visually-hidden {
  display: none;
}

.empty-body {
  height: 230px;
}